export const colors = {
    primaryGreen : '#016C34',
    primaryRed : '#DC2626',   
    primaryYellow : '#BFAF25',   
    primaryGrey : '#979797',   
    secondaryGreen : '#6BA989',   
    secondaryRed : '#FFC0CB',   
    secondaryRed2:'#f50057',
    purple : '#C5A8FF',
    
    lightblue : '#559BED',
    lightGreen: '#33895c',
    lighterGreen: '#A4C9B7',
    lightRed:'#ff7961',
    violet : '#C248AD',
    darkblue : '#5D5FEF',
    darkGreen: '#004b24',
    darkRed:'#ba000d',
    headerColor:'#3C3C3C',
    white : 'white',
    black : 'black',    
    bg1 : '#f9f9f9', 
    darkTextColor:'#4B4B4B',
    errorDialogBg :'#FDEDEE',
    darkerErrorDialog:'#E8777D',
    successDialogBg:'#def7ea',
    darkSuccessDialog:'#406e56',
    successDialogSubTitle:'#004b24',
    lightWarningColor:"rgb(244 238 193)"
}

export const Typography = {
primaryFont: `'Space Grotesk', sans-serif`,
// secondaryFont: `'Poppins', sans-serif`,
secondaryFont: `'Public Sans', sans-serif`,

}
